import {
  CheckPaymentFormTypeOption,
  PaidBillFormTypeOption,
  UnpaidBillFormTypeOption,
} from '../types/treatment';

type TypeTitleMap = {
  Bill: UnpaidBillFormTypeOption['title'];
  Expense: PaidBillFormTypeOption['title'];
  Check: CheckPaymentFormTypeOption['title'];
};

export const TYPE_TITLE: TypeTitleMap = {
  Bill: 'Unpaid Bill',
  Expense: 'Paid Bill',
  Check: 'Check Payment',
};
